
import './login.scss';

const Login = ()=>{
    return(
        <div>
            Login
        </div>
    )
}

export default Login;